/* eslint-disable no-var */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { CardBody, Card } from '@components/card/card';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getLookupListWithDynamic, GetLookupManagList } from '@store/NTX/Lookup/lookupsSlice';
import { useTranslation } from 'react-i18next';
import ModalComponent from '@components/Modal/ModalComponent';
import AddLookup from './AddLookupWithDynamic';
import UpdateLookup from './UpdateLookupWithDynamic';
import useLookupModule from '@hooks/Lookups/use-Lookup-Module';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import { getTablesLookupTypeList } from '@store/NTX/FlexValue/Form/formSlice';
import { useNavigate } from 'react-router-dom';

const LookupWithDynamic = () => {
  const Navigate = useNavigate();

  const { HasPermission } = usePermissions();
  const [search, setSearch] = useState('');
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [dataPerPage] = useState(10);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [categoryValue, setCategoryValue] = useState<string | null>();
  const [lookupType, setLookupType] = useState<string | null>();
  const [categoryName, setCategoryName] = useState<string>();
  const [moduleId, setModuleId] = useState<string>();
  const [ID, setID] = useState<string>(); //      استعماله في مكون التعديل

  const { LookupData } = useAppSelector(state => state.LookupData);
  const FilterByCategory = LookupData?.filter(f => f.categoryValue === categoryValue)[0];

  const { TablesLookupTypeList } = useAppSelector(state => state.Forms) as {
    TablesLookupTypeList: Array<{
      moduleId: string;
      moduleName: string;
      moduleName2: string;
      name: string;
      name2: string;
      lookupType: string;
    }>;
  };

  useEffect(() => {
    dispatch(getTablesLookupTypeList());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await dispatch(getLookupListWithDynamic({ LookupType: lookupType || '' })).unwrap();

        if (res.succeeded) {
          setData(res.data);
        } else {
          setData(null);
          setError('فشل في جلب البيانات');
        }
      } catch (err) {
        setData(null);
        setError('حدث خطأ أثناء جلب البيانات');
        console.error(err);
      } finally {
        // setLoading(false); // ✅ انتهاء التحميل سواء بنجاح أو خطأ
      }
    };

    if (lookupType) {
      fetchData();
      // dispatch(getLookupListWithDynamic({ LookupType: lookupType }));
    }
  }, [dispatch, lookupType]);

  // console.log(data);

 
  //________________________________
  const columns = [
    { title: t('Name'), key: 'Name', className: 'w-25' },
    { title: t('Application'), key: 'Application', className: 'w-25' },
    { title: t('Table'), key: 'Table', className: 'w-25' },

    { title: t('Code'), key: 'Code', className: 'w-25' },
    { title: t(''), key: 'action', className: 'text-end w-25' }
  ];

  const tableData = data?.map((item: any) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.meaning : item.meaning2,

      Application:
        i18n.language === 'en'
          ? TablesLookupTypeList.find(f => f.moduleId === moduleId)?.moduleName
          : TablesLookupTypeList.find(f => f.moduleId === moduleId)?.moduleName2,
      Table:
        i18n.language === 'en'
          ? TablesLookupTypeList.find(f => f.moduleId === moduleId)?.name
          : TablesLookupTypeList.find(f => f.moduleId === moduleId)?.name2,

      Code: item.lookupCode,

      action: (
        <>
          <div className='btn-group'>
            <button
              // hidden={FilterByCategory?.isSystemLookup}
              disabled={item.dunamicFormId === null}
              type='button'
              className='btn btn-sm btn-outline-theme'
              onClick={() => Navigate(`/NTX/Forms/${item.dunamicFormId}/AddFormColumns`)}
            >
              <i className='far fa-lg fa-fw me-2 fa-edit'></i>
              {t('fieldsForm')}
            </button>
          </div>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });
  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'DataTypesForms',
      link: null
    }
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName='DataTypesForms' />

      <Card>
        {/* <Loading loading={loading} error={error}> */}
        <CardBody>
          <div className='row mb-3'>
            <div className='col-xl-3'>
              <div className='input-group flex-nowrap mb-2'>
                <span className='input-group-text'>{t('Search')}</span>
                <input
                  type='text'
                  autoComplete='off'
                  className='form-control '
                  onChange={e => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>

            <div className='col-xl-4'>
              <div className='input-group flex-nowrap mb-2'>
                <span className='input-group-text'>{t('Application')}</span>
                <Select
                  classNamePrefix='react-select'
                  className='w-100'
                  // isLoading={loading2}
                  isSearchable={true}
                  isClearable
                  options={
                    TablesLookupTypeList &&
                    TablesLookupTypeList?.filter(
                      (item: any, index, self) => index === self.findIndex((t: any) => t.moduleId === item.moduleId)
                    )?.map((item: any) => ({
                      value: item.moduleId,
                      label: i18n.language === 'en' ? item.moduleName : item.moduleName2
                    }))
                  }
                  onChange={(option: any) => {
                    setCategoryValue('');
                    setModuleId(option === null ? null : option.value);
                    if (option === null) {
                      setCategoryValue(null);
                    }
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>

            <div className='col-xl-4'>
              <div className='input-group flex-nowrap mb-2'>
                <span className='input-group-text'>{t('Type')}</span>
                <Select
                  isSearchable
                  // options={optionSelect}
                  classNamePrefix='react-select'
                  className='w-100'
                  name='Select'
                  options={
                    TablesLookupTypeList &&
                    TablesLookupTypeList?.filter((f: any) => f.moduleId === moduleId).map((item: any) => ({
                      value: item.lookupType,
                      label: i18n.language === 'en' ? item.name : item.name2
                    }))
                  }
                  onChange={option => {
                    // setCategoryValue(option?.value);
                    setLookupType(option?.value);
                    setCurrentPage(1);
                    setCategoryName(option?.label);
                  }}
                  placeholder='اخـتــر ... '
                  // defaultValue={{
                  //   value: LookupData[0]?.categoryValue,
                  //   label: LookupData[0]?.categoryName
                  // }}
                />
              </div>
            </div>

            <div className='col-xl-1 text-end'>
              <button
                // hidden={FilterByCategory?.isSystemLookup}
                type='button'
                className='btn  w-100 btn-theme mb-2'
                data-bs-toggle='modal'
                data-bs-target='#AddLookup'
              >
                <i className='far fa-lg fa-fw   fa-plus'></i>
              </button>
            </div>
          </div>

          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={10}
            theadClass=''
            tableClass='table text-nowrap table-hover '
            // enableSearch
            // showRecordsSelector
          />
        </CardBody>
        {/* </Loading> */}
      </Card>

      {/* <ModalComponent id={'AddLookup'} title={t('Add')} size='sm'>
        {categoryValue && categoryName && (
          <AddLookup
            categoryName={categoryName}
            categoryValue={categoryValue}
            FilterByCategory={FilterByCategory?.lookupsList}
            moduleId={moduleId}
          />
        )}
      </ModalComponent>

      <ModalComponent id={'UpdateLookup'} title={t('Edit')} size='sm'>
        {ID && categoryValue && categoryName && (
          <UpdateLookup
            categoryName={categoryName}
            categoryValue={categoryValue}
            FilterByCategory={FilterByCategory?.lookupsList}
            ID={ID}
            moduleId={moduleId}
          />
        )}
      </ModalComponent> */}
    </>
  );
};

export default LookupWithDynamic;
